export default "__VITE_ASSET__HKlZ4gbe__"